import { EditorView, basicSetup } from "codemirror"
import { sql, MySQL, PostgreSQL } from "@codemirror/lang-sql"
import { oneDark } from "@codemirror/theme-one-dark"
import { EditorState } from "@codemirror/state"
import { placeholder } from "@codemirror/view"

let localEditor, prodEditor, outputEditor, rollbackEditor;

const getSqlExt = (d) => sql({ dialect: d === 'mysql' ? MySQL : PostgreSQL });

export function initEditors(localEl, prodEl, dialect = 'mysql', onUpdate) {
  const commonExtensions = [
    basicSetup,
    oneDark,
    EditorView.lineWrapping,
    EditorView.updateListener.of((update) => {
      if (update.docChanged && onUpdate) onUpdate();
    })
  ];

  localEditor = new EditorView({
    state: EditorState.create({
      doc: "",
      extensions: [...commonExtensions, getSqlExt(dialect), placeholder("-- Paste Local CREATE TABLE SQL here...")]
    }),
    parent: localEl
  });

  prodEditor = new EditorView({
    state: EditorState.create({
      doc: "",
      extensions: [...commonExtensions, getSqlExt(dialect), placeholder("-- Paste Production CREATE TABLE SQL here...")]
    }),
    parent: prodEl
  });

  const style = document.createElement('style');
  style.textContent = `
    .cm-editor { height: 100% !important; }
    .cm-scroller { overflow: auto !important; }
    .cm-focused { outline: none !important; }
  `;
  document.head.appendChild(style);
}

export function initOutputEditors(sqlEl, rollbackEl, dialect = 'mysql') {
  const extensions = [basicSetup, oneDark, EditorView.lineWrapping, getSqlExt(dialect), EditorState.readOnly.of(true)];
  outputEditor = new EditorView({ state: EditorState.create({ doc: "", extensions }), parent: sqlEl });
  rollbackEditor = new EditorView({ state: EditorState.create({ doc: "", extensions }), parent: rollbackEl });
}

/**
 * 核心取值函数：支持 local, prod, output, rollback
 */
export function getSql(type) {
  const mapping = { 
    local: localEditor, 
    prod: prodEditor, 
    output: outputEditor, 
    rollback: rollbackEditor,
    sql: outputEditor, // 兼容旧 ID
    rollbackSql: rollbackEditor // 兼容旧 ID
  };
  const editor = mapping[type];
  return editor ? editor.state.doc.toString() : "";
}

export function setSql(type, value) {
  const mapping = { local: localEditor, prod: prodEditor, output: outputEditor, rollback: rollbackEditor };
  const editor = mapping[type];
  if (editor && value !== undefined) {
    editor.dispatch({
      changes: { from: 0, to: editor.state.doc.length, insert: value }
    });
  }
}
